export default "__VITE_ASSET__pl$_KWdJ__"